export function getLocalStorage(key) {
  const value = window.localStorage.getItem(key);
  return value;
}

export function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}
